import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import PhotoUploader from '../../components/photo-uploader';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import AccountCircleIcon from '@material-ui/icons/AccountCircle';

import React, { useState } from 'react';

import { baseTheme } from '../../theme';
import EditLeaderSettings from '../../components/account-forms/edit-account-forms/edit-leader-account-form';
import EditIndividualAccount from '../../components/account-forms/edit-account-forms/edit-individual-account';
import { useDispatch, useSelector } from 'react-redux';
import SubmitButton from '../../components/form-elements/submit-button';
import AddContactEmail from '../../components/account-forms/edit-account-forms/add-contact-email';
import { loadUserDetails, setAppLoadingState } from '../../store';
import { removeImage, uploadProfileImages } from '../../services/storage';
import { updateUserProfile } from '../../store/users/actions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    formContainer: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      borderRadius: '5px',
      marginLeft: theme.spacing(0),
      marginRight: theme.spacing(3),
      padding: theme.spacing(1),
    },
    textBlock: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    submitButton: {
      fontSize: '2em',
    },
  }),
);

export default function AccountSettingsPage() {
  const classes = useStyles(baseTheme);
  const auth = useSelector((state: any) => state.auth);
  const profile = useSelector((state: any) => state.user.profile);
  const [showEmailChange, setShowEmailChange] = useState(false);
  const [photoModalOpen, setPhotoModalOpen] = useState(false);
  const dispatch = useDispatch();
  const formRender = () => {
    if (auth.loading) {
      return null;
    }

    if (profile.userType === 'leader') {
      return (<EditLeaderSettings photoUrl={ profile.photoUrl }/>);
    }

    if (profile.userType === 'user') {
      return (<EditIndividualAccount photoUrl={ profile.photoUrl } />);
    }

    return null;
  };
  const openEmailChange = () => {
    setShowEmailChange(true);
  };
  const hideEmailChange = () => {
    setShowEmailChange(false);
  };
  const togglePhotoModal = () => setPhotoModalOpen(!photoModalOpen);
  const uploadProfileImage = async (blobUrl: string, fileName: string) => {
    const userId = auth.currUser.uid;
    setAppLoadingState(dispatch, true);
    const oldPhotoUrl = profile.photoUrl;
    profile.photoUrl = await uploadProfileImages(blobUrl, `${userId}_${fileName}`);
    await updateUserProfile(auth.currUser, profile)
      .then(async (result) => {
        console.log(result);
        const userDetails = await loadUserDetails(userId);
        dispatch(userDetails);
        await removeImage(oldPhotoUrl);
        setTimeout(
          () => window.location.reload(),
          1000);
      })
      .catch((error) => {
        console.log(error);
      });
    setAppLoadingState(dispatch, false);
    togglePhotoModal();
  };
  const secondaryFormRenderer = () => {
    if (auth.loading) {
      return null;
    }
    if (showEmailChange) {
      return (<AddContactEmail cancel={hideEmailChange}/>);
    }
    return (
        <SubmitButton
          className={classes.submitButton}
          onClick={openEmailChange}
          text="Add New Contact Email"
          variant="light"
        />
    );
  };
  const imageFormRenderer = () => {
    if (auth.loading) {
      return null;
    }
    return (
      <SubmitButton
        className={classes.submitButton}
        onClick={togglePhotoModal}
        text="Add Profile Image"
        variant="light"
      />
    );
  };

  return (
    <Grid item container direction="column" className={classes.root}>
      <Typography variant="h4" color="primary">
        <AccountCircleIcon /> Account Settings
      </Typography>

      <Grid item container xs={12}>
        <Grid item container direction="column" xs={12} md={5} className={classes.formContainer}>
          {formRender()}
          {imageFormRenderer()}
        </Grid>

        <Grid item container direction="column" xs={12} md={6}>
          <Grid item className={classes.textBlock}>
            <Typography variant="h5" color="primary">
              Make updates to your account settings.
            </Typography>
            <Typography variant="body1">
              Thank you for keeping your account information updated so that
              we may continue to provide you with the best service possible.
              Click on the links to the left to make changes to your information.
            </Typography>
          </Grid>

          <Grid item className={classes.textBlock}>
            <Typography variant="h5" color="primary">
              Stay connected with us.
            </Typography>
            <Typography variant="body1">
              For big announcements or updates, we will reach out to you with an
              email.  Because we don’t plan to do that very often, we have some
              other ways to stay connected with us.
              <br /><br />
              You can also check our About Reliht page for updates and announcements.
              And of course, you can always find us on Facebook and Instagram.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Modal
        open={photoModalOpen}
        onClose={togglePhotoModal}
        >
          <PhotoUploader cancelUpload={togglePhotoModal} uploadPhoto={uploadProfileImage} title="Profile Picture" />
      </Modal>
    </Grid>
  );
}
